define('features/overlayGameLauncher/adventureTwo/summary/subscriptionHandlers',[
    'underscore'
], function (_) {

    function updateObservableDataWithKey (observableDataToUpdate, key, data) {
        observableDataToUpdate(_.set(observableDataToUpdate(), key, data));
    }

    return function AdventureTwoSummarySubscriptionHandlers (adventureTwoObservableData) {
        return {
            handleGemsUpdate: _.partial(updateObservableDataWithKey, adventureTwoObservableData, 'summary.gems'),
            handleXpUpdate: _.partial(updateObservableDataWithKey, adventureTwoObservableData, 'summary.xp')
        };
    };

});

